const MAX_RECENT_GUIDES = 6;

const initialState = {
  bookmarks: [],
  recentGuideIds: [],
  visitCounts: {},
  searchQuery: "",
};

export default function reducerCase(state = initialState, action) {
  switch (action.type) {
    case "HELP_GUIDE_VIEW": {
      const guideId = action.payload;
      if (!guideId) return state;

      return {
        ...state,
        recentGuideIds: [
          guideId,
          ...state.recentGuideIds.filter((id) => id !== guideId),
        ].slice(0, MAX_RECENT_GUIDES),
        visitCounts: {
          ...state.visitCounts,
          [guideId]: (state.visitCounts[guideId] || 0) + 1,
        },
      };
    }

    case "HELP_GUIDE_TOGGLE_BOOKMARK": {
      const guideId = action.payload;
      if (!guideId) return state;

      const isBookmarked = state.bookmarks.includes(guideId);
      return {
        ...state,
        bookmarks: isBookmarked
          ? state.bookmarks.filter((id) => id !== guideId)
          : [guideId, ...state.bookmarks],
      };
    }

    case "HELP_GUIDE_SET_SEARCH":
      return {
        ...state,
        searchQuery: action.payload || "",
      };

    default:
      return state;
  }
}
